var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.animation)?_c('div',{staticClass:"word"},_vm._l((_vm.word),function(letter,key){return _c('span',{class:['word--letter', {'word--letter-animate': _vm.animation && _vm.isAnimated}],style:(("animation-duration: " + (_vm.delay + (key * _vm.speed)) + "ms "))},[_vm._v(_vm._s(letter))])}),0):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6d1ccb87","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TextAnimation.vue
// module id = 270
// module chunks = 0